import styles from "./submit.module.scss";
import { Button } from "cdhs-ui-library";
import {
  BsCheckCircleFill,
  BsArrowLeftShort,
  BsArrowRightShort,
} from "react-icons/bs";
import { useAppDispatch, useAppSelector } from "../../store/store";
import { useNavigate } from "react-router";
import { getQuestion, submitSurvey } from "../../store/survey/surveySlice";
import { ROUTES } from "../../config/routes";
import { useTranslations } from "../../contexts/LanguageContext";
import { useState } from "react";

function Submit() {
  const t = useTranslations();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const language = useAppSelector((state) => state.lang);
  const user = useAppSelector(state => state.user.user);
  const survey = useAppSelector(state => state.survey.survey);
  const [disableSubmitButton, setDisableSubmitButton] = useState<boolean>()
  const answersDeclined = useAppSelector(state => state.survey.allAnswersDeclined)

  const handleConfirm = () => {
    const session = {
      SessionId: user?.SessionId,
      ClientId: user?.ClientId,
    };
    setDisableSubmitButton(prevstate => !prevstate)
    dispatch(submitSurvey({ ...session, SendW9: false }))
    const isDeclined = answersDeclined ? true : false;

    dispatch(submitSurvey({ ...session, SendW9: false, Decline: isDeclined }))
      .unwrap()
      .then(() => {
        navigate(ROUTES.SURVEY_END);
      })
      .catch((error) => {
        console.error("FAILED TO SUBMIT SURVEY: ", error);
      });
  };

  const handleReturn = async () => {
      const dispatchResult = dispatch(getQuestion({ //return redux object
        SessionId: user?.SessionId,
        ClientId: user?.ClientId,
        Language: language.language,
        QuestionId: user?.LastQuestionId == 0 ? survey?.QuestionId : user?.LastQuestionId,
        SubmitType: "LastQ"
      }));
      const result = await dispatchResult
      if (result) {
        navigate(ROUTES.SURVEY_QUESTIONS);
      } else {
        return
      }
  };

  return (
    <section className={styles.overlay} aria-labelledby="submit-page-heading">
      <div className={styles.mainContainer}>
        <div className={styles.header} aria-hidden="true">
          <BsCheckCircleFill />
        </div>
        <div className={styles.content}>
          <>
            <h1 id="submit-page-heading">{t('submitPage_title', 'You have completed the survey!')}</h1>
            <p>
              {t('submitPage_instructions', 'Please select “Confirm and submit” to submit your survey or “Cancel” to return to the survey to make changes.')}
            </p>
          </>


          <p>
            <strong>
              {t('submitPage_warning', "Please note that once you submit your answers, you won't be able to change them.")}
            </strong>
          </p>

          <Button
            caption={t('submitPage_confirmButton', 'Confirm and submit')}
            variant="NYTD"
            iconPosition="Right"
            image={<BsArrowRightShort />}
            onClick={handleConfirm}
            disabled={disableSubmitButton}
          />
          <Button
            caption={t('submitPage_cancelButton', 'Cancel and return to survey')}
            variant="NYTD"
            iconPosition="Left"
            mode="light"
            image={<BsArrowLeftShort />}
            onClick={handleReturn}
          />
        </div>
      </div>
    </section>
  );
}

export default Submit;